export default __webpack_public_path__ + "static/media/milestone.865b2ad1.svg";